(() => {
  'use strict';
  if (window.OcchioWishlist) return;

  const KEY = 'occhio:wishlist:v1';
  const MAX = 60;
  const configEl = document.getElementById('occhio-wishlist-config');
  let cfg = {};
  try { cfg = JSON.parse(configEl ? configEl.textContent : '{}'); } catch (_) { cfg = {}; }
  const t = cfg.t || {};
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.2s-7.6-4.6-9.2-9.4C1.7 7.6 3.7 4.4 7 4.2c2-.1 3.6 1 5 2.8 1.4-1.8 3-2.9 5-2.8 3.3.2 5.3 3.4 4.2 6.6-1.6 4.8-9.2 9.4-9.2 9.4z"/></svg>';

  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value.filter(item => item && typeof item.handle === 'string') : [];
    } catch (_) { return []; }
  };
  const write = list => { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (_) {} };
  const absolute = src => (src && src.startsWith('//') ? 'https:' + src : src || '');
  const productUrl = handle => root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle);
  const group = (value, thousands, decimal, decimals) => {
    const [whole, fraction] = (value / 100).toFixed(decimals).split('.');
    return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
  };
  const money = cents => {
    if (!Number.isFinite(cents)) return '';
    const format = cfg.money_format || '€{{amount_with_comma_separator}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      if (key === 'amount_with_comma_separator') return group(cents, '.', ',', 2);
      if (key === 'amount_no_decimals_with_comma_separator') return group(cents, '.', ',', 0);
      if (key === 'amount_no_decimals') return group(cents, ',', '.', 0);
      return group(cents, ',', '.', 2);
    });
  };
  const shortTitle = item => {
    let title = item.title || item.handle;
    const brand = (item.brand || '').trim();
    if (brand && title.toLowerCase().startsWith(brand.toLowerCase() + ' | ')) title = title.slice(brand.length + 3);
    return title.split(' | ').join(' · ');
  };

  const track = (name, item) => {
    const props = {
      ProductName: item.title || item.handle,
      ProductHandle: item.handle,
      ProductID: item.id || '',
      Brand: item.brand || '',
      URL: location.origin + productUrl(item.handle),
      ImageURL: absolute(item.image),
      Price: Number.isFinite(item.price) ? item.price / 100 : null,
      Locale: document.documentElement.lang || ''
    };
    try {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') window.klaviyo.track(name, props);
      else (window._learnq = window._learnq || []).push(['track', name, props]);
    } catch (_) {}
  };

  const itemFrom = el => ({
    handle: el.dataset.occhioWish,
    id: el.dataset.wishId || '',
    title: el.dataset.wishTitle || '',
    brand: el.dataset.wishBrand || '',
    image: el.dataset.wishImage || '',
    price: Number(el.dataset.wishPrice),
    added: Date.now()
  });

  const sync = () => {
    const list = read();
    const saved = new Set(list.map(item => item.handle));
    document.querySelectorAll('[data-occhio-wish]').forEach(button => {
      const on = saved.has(button.dataset.occhioWish);
      button.setAttribute('aria-pressed', String(on));
      button.setAttribute('aria-label', (on ? t.remove_aria : t.add_aria) + ': ' + (button.dataset.wishTitle || ''));
      const label = button.querySelector('[data-wish-label]');
      if (label) label.textContent = on ? t.saved : t.save;
    });
    document.querySelectorAll('[data-occhio-wish-count]').forEach(count => {
      count.textContent = String(list.length);
      count.hidden = list.length === 0;
    });
  };

  const toggle = button => {
    const handle = button.dataset.occhioWish;
    if (!handle) return;
    let list = read();
    const existing = list.find(item => item.handle === handle);
    if (existing) {
      list = list.filter(item => item.handle !== handle);
      write(list);
      track('Removed from Wishlist', existing);
    } else {
      const item = itemFrom(button);
      list = [item, ...list.filter(entry => entry.handle !== handle)];
      write(list);
      track('Added to Wishlist', item);
    }
    sync();
    if (panel && panel.open) render();
  };

  /* Pannello Preferiti */
  let panel = null;
  const buildPanel = () => {
    panel = document.createElement('dialog');
    panel.className = 'occhio-wish-panel';
    panel.setAttribute('aria-labelledby', 'occhio-wish-panel-title');
    panel.innerHTML =
      '<div class="occhio-wish-panel__inner">' +
        '<div class="occhio-wish-panel__head"><h2 id="occhio-wish-panel-title"></h2>' +
        '<button type="button" class="occhio-wish-panel__close" data-wish-close></button></div>' +
        '<ul class="occhio-wish-panel__list" data-wish-list></ul>' +
        '<p class="occhio-wish-panel__empty" data-wish-empty hidden></p>' +
        '<p class="occhio-wish-panel__note"></p>' +
      '</div>';
    panel.querySelector('h2').textContent = t.title || '';
    const close = panel.querySelector('[data-wish-close]');
    close.textContent = '×';
    close.setAttribute('aria-label', t.close || '');
    panel.querySelector('[data-wish-empty]').textContent = t.empty || '';
    panel.querySelector('.occhio-wish-panel__note').textContent = t.note || '';
    panel.addEventListener('click', event => {
      if (event.target === panel || event.target.closest('[data-wish-close]')) { panel.close(); return; }
      const remove = event.target.closest('[data-wish-remove]');
      if (remove) {
        const handle = remove.dataset.wishRemove;
        const item = read().find(entry => entry.handle === handle);
        write(read().filter(entry => entry.handle !== handle));
        if (item) track('Removed from Wishlist', item);
        sync(); render();
      }
    });
    document.body.appendChild(panel);
  };

  const live = new Map();
  const refresh = async handle => {
    if (live.has(handle)) return live.get(handle);
    const request = fetch(productUrl(handle) + '.js', {credentials: 'same-origin'})
      .then(response => (response.ok ? response.json() : null))
      .catch(() => null);
    live.set(handle, request);
    return request;
  };

  const render = () => {
    if (!panel) buildPanel();
    const list = read();
    const ul = panel.querySelector('[data-wish-list]');
    ul.replaceChildren();
    panel.querySelector('[data-wish-empty]').hidden = list.length !== 0;
    list.forEach(item => {
      const li = document.createElement('li');
      li.className = 'occhio-wish-item';
      const link = document.createElement('a');
      link.className = 'occhio-wish-item__link';
      link.href = productUrl(item.handle);
      if (item.image) {
        const img = document.createElement('img');
        img.src = absolute(item.image); img.alt = ''; img.loading = 'lazy'; img.width = 96; img.height = 96;
        link.appendChild(img);
      }
      const text = document.createElement('span');
      text.className = 'occhio-wish-item__text';
      const brand = document.createElement('span'); brand.className = 'occhio-wish-item__brand'; brand.textContent = item.brand;
      const title = document.createElement('span'); title.className = 'occhio-wish-item__title'; title.textContent = shortTitle(item);
      const price = document.createElement('span'); price.className = 'occhio-wish-item__price'; price.textContent = money(item.price);
      text.append(brand, title, price);
      link.appendChild(text);
      const remove = document.createElement('button');
      remove.type = 'button'; remove.className = 'occhio-wish-item__remove';
      remove.dataset.wishRemove = item.handle; remove.textContent = t.remove || '';
      remove.setAttribute('aria-label', (t.remove_aria || '') + ': ' + (item.title || item.handle));
      li.append(link, remove);
      ul.appendChild(li);
      refresh(item.handle).then(product => {
        if (!product) { price.textContent = t.sold_out || ''; li.classList.add('is-unavailable'); return; }
        if (product.id && !item.id) {
          const list = read();
          const stored = list.find(entry => entry.handle === item.handle);
          if (stored) { stored.id = String(product.id); write(list); }
        }
        if (product.featured_image && !item.image) {
          const img = document.createElement('img');
          img.src = absolute(product.featured_image); img.alt = ''; img.loading = 'lazy'; img.width = 96; img.height = 96;
          link.prepend(img);
        }
        if (product.available) price.textContent = money(product.price);
        else { price.textContent = t.sold_out || ''; li.classList.add('is-unavailable'); }
      });
    });
  };

  const open = () => {
    render();
    if (typeof panel.showModal === 'function') panel.showModal(); else panel.setAttribute('open', '');
  };

  /* Icona Preferiti accanto al carrello */
  const mountHeader = () => {
    if (document.querySelector('[data-occhio-wish-open]')) return;
    const cart = document.getElementById('cart-icon-bubble');
    if (!cart || !cart.parentNode) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'occhio-wish-header';
    button.dataset.occhioWishOpen = '';
    button.setAttribute('aria-label', t.title || '');
    button.innerHTML = HEART + '<span class="occhio-wish-header__count" data-occhio-wish-count hidden>0</span>';
    cart.parentNode.insertBefore(button, cart);
  };

  /* Pulsante sotto Aggiungi al carrello nella scheda prodotto */
  const mountProduct = () => {
    const data = cfg.product;
    if (!data || !data.handle) return;
    if (document.querySelector('.occhio-wish--product')) return;
    const form = document.querySelector('#MainContent product-form');
    if (!form || !form.parentNode) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'occhio-wish occhio-wish--product';
    button.dataset.occhioWish = data.handle;
    button.dataset.wishId = data.id ? String(data.id) : '';
    button.dataset.wishTitle = data.title || '';
    button.dataset.wishBrand = data.brand || '';
    button.dataset.wishImage = data.image || '';
    button.dataset.wishPrice = String(data.price);
    button.setAttribute('aria-pressed', 'false');
    button.innerHTML = HEART + '<span data-wish-label></span>';
    form.parentNode.insertBefore(button, form.nextSibling);
  };

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-occhio-wish]');
    if (button) { event.preventDefault(); event.stopPropagation(); toggle(button); return; }
    if (event.target.closest('[data-occhio-wish-open]')) { event.preventDefault(); open(); }
  }, true);

  window.addEventListener('storage', event => { if (event.key === KEY) sync(); });

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; mountHeader(); sync(); });
  };

  const init = () => {
    mountHeader();
    mountProduct();
    sync();
    new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true});
    document.addEventListener('occhio:catalog-rendered', schedule);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();

  window.OcchioWishlist = {read, open, sync};
})();
